import { Observable } from 'rxjs';

import { MatDialogRef } from '@angular/material/dialog';

import { SnCamera, SnLayer } from '@lib/api/entities';
import { SnLiveUser } from '@lib/live-tracking/models';

import { IFsMap } from '../types';

export abstract class FsMapCamerasServiceProvider<TMap extends IFsMap> {
  abstract readonly id: string;
  abstract readonly geospatialProvider: string;

  // TODO: Currently markers are Google Only. To prevent Google code in Facade type any is used.
  // Once markers are refactored, we can add the type here
  abstract advancedMarkers: any[];
  abstract pendingCameras: string[];
  abstract clustering: boolean;
  abstract isAvailable: boolean;
  abstract canChange: boolean;
  abstract sentrySearchResults: any[];
  abstract lprCameras: any[];
  abstract advancedClusters: any[];
  abstract camerasParam: string;
  abstract deselectedCameraGroupsParam: string;
  abstract activeLayerPopouts: any[];
  abstract cameraLayerObjects: any[];
  abstract followMarker: any;
  abstract advancedSkydioMarkers: any[];

  // Observables
  abstract get hovered$(): Observable<SnCamera>;
  abstract get cameraSelected$(): Observable<SnCamera>;
  abstract get selectedUsers$(): Observable<{ users: SnLiveUser[]; channelType: string }>;
  abstract get axonCameraHovered$(): Observable<boolean>;
  abstract get uavMouseOver$(): Observable<void>;
  abstract get uavMouseOut$(): Observable<void>;
  abstract get firstTwoClicked$(): Observable<void>;
  // TODO: Should be DrawingShapeCompleteDialog however it is currently in the dashboard app
  abstract get shapeComplete$(): Observable<{ shape: any; dialogRef: MatDialogRef<any> }>;

  // Functions
  abstract getMarkers(): unknown[];
  abstract onMapLoaded(map: TMap): void;
  abstract addToMap(): void;
  abstract removeFromMap(): void;
  abstract openFususInvestigate(): void;
  abstract openPopup(camera: SnCamera): void;
  abstract addPolyline(camera: SnCamera, element: Element): void;
  abstract removePolyline(): void;
  abstract clearPolylines(): void;
  abstract removeLine(): void;
  abstract cancelDocking(): void;
  abstract cameraSelected(camera: SnCamera): void;
  abstract cameraHovered(camera: SnCamera): void;
  abstract emitFirstTwoClicked(): void;
  abstract registerViewTabsFirstTwoClick(click$: Observable<void>): void;
  abstract openPopout(
    layer: SnLayer,
    marker: unknown,
    fields: string[],
    cameraMarker: unknown,
  ): void;
  abstract updateCameraLabelVisibility(): void;
}
